import { Record } from 'immutable';
import { convertRawValues } from '../lib/utils/record_utils';

export default class TransactionEntryRecord extends Record({
  id: null,
  _type: '',
  objectID: null,
  amount: '',
  arrears_position: '',
  fully_reversed: false,
  payment_plan_id: null,
  pending: false,
  principal_balance: '',
  reversed_by_id: null,
  reversing_id: null,
  total_balance: '',
  transaction_type: '',
  value_date: '',
  note: '',
  payment_plan: {},
  gl_entry: null,
  gl_entries: [],
}) {
  constructor(data) {
    data = convertRawValues(data);
    super(data);
  }
}
